var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sys-register-base", {
    attrs: {
      loading: _vm.loading,
      model: _vm.model,
      title: _vm.title,
      icon: "mdi-clock-check-outline",
      show: _vm.dialog,
      maxWidth: "50%",
    },
    on: {
      onSave: _vm.save,
      "update:model": function ($event) {
        _vm.model = $event
      },
      "update:show": function ($event) {
        _vm.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _c(
              "v-container",
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _c("sys-select-teacher-work-regime", {
                          attrs: {
                            model: _vm.model.teacher_work_regime_id,
                            error: !!_vm.errors.teacher_work_regime_id,
                            errors: _vm.errors.teacher_work_regime_id,
                            label: "Regime de Trabalho*",
                            dense: "",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(
                                _vm.model,
                                "teacher_work_regime_id",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            type: "number",
                            error: !!_vm.errors.work_load_min,
                            "error-messages": _vm.errors.work_load_min,
                            label:
                              "CH Mínima Total (Sala de Aula + Atividades)*",
                          },
                          model: {
                            value: _vm.model.work_load_min,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "work_load_min", $$v)
                            },
                            expression: "model.work_load_min",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            type: "number",
                            step: "0.01",
                            suffix: "%",
                            error: !!_vm.errors.percent_activities,
                            "error-messages": _vm.errors.percent_activities,
                            label: "Percentual mínimo de CH de Atividades*",
                          },
                          model: {
                            value: _vm.model.percent_activities,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "percent_activities", $$v)
                            },
                            expression: "model.percent_activities",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("emc-alert-snackbar", {
              attrs: {
                show: !!_vm.message.length,
                message: _vm.message,
                color: _vm.error ? "error" : "success",
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }